<script>
	import Vue from 'vue'
	import Echo from "laravel-echo"
	import Pusher from "pusher-js"
	import { ConsoleLogger } from '@/console-logger'

	export default {
		name: 'echo-client-core',
		data() {
			return {
				echo: null,

				logMessages: [],
				logger: new ConsoleLogger('EchoClient', 'background: #00aa00; color: white'),
			}
		},
		created() {
			if (!Vue.prototype.$echoClient) {
				Object.defineProperty(Vue.prototype, '$echoClient', {value: this})
			}

			let echoKey = window.ECHO_KEY || process.env.VUE_APP_ECHO_KEY;

			console.log('echoKey', echoKey);

			let echoOptions = {
				broadcaster: process.env.VUE_APP_ECHO_BROADCASTER,
				key: process.env.VUE_APP_ECHO_KEY,
				cluster: process.env.VUE_APP_ECHO_CLUSTER,

				// For some reason we have to pass an instance of pusher to echo or it doesn't work
				client: new Pusher(process.env.VUE_APP_ECHO_KEY, {
					cluster: process.env.VUE_APP_ECHO_CLUSTER
				})
			};

			this.echo = new Echo(echoOptions);

			this.logMessage(`Assigned to Vue.$echoClient`)
			console.log('echoOptions', echoOptions);
		},
		methods: {
			getEcho() {
				return this.echo;
			},
			channel(channel) {
				//this.logMessage(`Opening channel "${channel}"..`);

				return this.echo.channel(channel);
			},
			listen(channel, event, callback) {
				//this.logMessage(`Listening to channel "${channel}.${event}"..`);

				this.channel(channel).listen(event, function() {
					console.log(`Calling callback of ${channel}.${event}`, callback);
				});
			},

			// Logger
			clearLog () {
				console.log('Clearing log!')

				this.logMessages = []
			},
			logMessage (message) {
				this.logger.logMessage(message)

				this.logMessages.push(message)
			},
		},
		render: function (h) {
			return h() // avoid warning message
		}
	}
</script>
